import _implicitStylesheets from "./imageUploader.css";
import _implicitScopedStylesheets from "./imageUploader.scoped.css?scoped=true";
import _lightningSpinner from "lightning/spinner";
import _c360ButtonIcon from "c360/buttonIcon";
import _appxDeleteIconButton from "appx/deleteIconButton";
import _c360Icon from "c360/icon";
import _appxMessageBox from "appx/messageBox";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<p class="uploading-label${0}"${2}>${"t1"}</p>`;
const $fragment2 = parseFragment`<input type="file"${"a0:accept"} class="file-input mouse-capture${0}"${"a0:aria-label"}${"a0:disabled"}${2}>`;
const $fragment3 = parseFragment`<div class="slds-col mouse-ignore${0}"${2}><div class="upload-text${0}"${2}>${"t2"}</div></div>`;
const $fragment4 = parseFragment`<img class="preview-image${0}"${"a0:src"}${"s0"}${"a0:alt"}${2}>`;
const $fragment5 = parseFragment`<span${3}>${"t1"}</span>`;
const stc0 = {
  classMap: {
    "slds-grid": true,
    "slds-wrap": true
  },
  key: 0
};
const stc1 = {
  classMap: {
    "slds-grid": true
  },
  key: 2
};
const stc2 = {
  classMap: {
    "slds-size_2-of-3": true
  },
  key: 3
};
const stc3 = {
  classMap: {
    "uploading-container": true
  },
  key: 4
};
const stc4 = {
  classMap: {
    "uploading-spinner": true
  },
  key: 5
};
const stc5 = {
  "drop-area": true
};
const stc6 = {
  classMap: {
    "slds-grid": true,
    "slds-gutters": true,
    "mouse-ignore": true
  },
  key: 10
};
const stc7 = {
  classMap: {
    "slds-col": true
  },
  key: 11
};
const stc8 = {
  "mouse-capture": true
};
const stc9 = {
  classMap: {
    "preview": true,
    "slds-size_1-of-3": true,
    "slds-m-bottom_small": true,
    "slds-m-left_small": true,
    "slds-m-right_small": true
  },
  key: 17
};
const stc10 = {
  classMap: {
    "inner-preview": true,
    "slds-grid": true
  },
  key: 18
};
const stc11 = {
  classMap: {
    "slds-grid": true,
    "slds-grid_align-spread": true
  },
  key: 23
};
const stc12 = {
  classMap: {
    "required-message": true
  },
  key: 24
};
const stc13 = {
  classMap: {
    "slds-size_1-of-4": true,
    "slds-p-horizontal_medium": true,
    "slds-m-bottom_small": true,
    "mouse-ignore": true
  },
  key: 27
};
const stc14 = {
  classMap: {
    "help-text": true
  },
  key: 28
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {ncls: api_normalize_class_name, c: api_custom_element, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, h: api_element, b: api_bind} = $api;
  const {_m0, _m1, _m2, _m3, _m4, _m5, _m6, _m7} = $ctx;
  return [api_element("div", stc0, [api_element("div", {
    className: api_normalize_class_name($cmp.computedCss),
    key: 1
  }, [api_element("div", stc1, [api_element("div", stc2, [$cmp.isUploading ? api_element("div", stc3, [api_element("div", stc4, [api_custom_element("lightning-spinner", _lightningSpinner, {
    props: {
      "alternativeText": $cmp.uploadProgressLabel,
      "size": "large"
    },
    key: 6
  }), api_static_fragment($fragment1, 8, [api_static_part(1, null, api_dynamic_text($cmp.uploadProgressLabel))])])]) : null, !$cmp.isUploading ? api_element("div", {
    classMap: stc5,
    key: 9,
    on: {
      "dragenter": _m0 || ($ctx._m0 = api_bind($cmp.handleDrag)),
      "dragover": _m1 || ($ctx._m1 = api_bind($cmp.handleDrag)),
      "dragleave": _m2 || ($ctx._m2 = api_bind($cmp.handleDragLeave)),
      "drop": _m3 || ($ctx._m3 = api_bind($cmp.handleDrop)),
      "click": _m4 || ($ctx._m4 = api_bind($cmp.clickUpload))
    }
  }, [api_element("div", stc6, [api_element("div", stc7, [api_static_fragment($fragment2, 13, [api_static_part(0, {
    on: {
      "change": _m6 || ($ctx._m6 = api_bind($cmp.handleUpload))
    },
    attrs: {
      "accept": $cmp.acceptedFormats,
      "aria-label": $cmp.ariaLabel,
      "disabled": $cmp.disabled ? "" : null
    }
  }, null)]), api_custom_element("c360-button-icon", _c360ButtonIcon, {
    classMap: stc8,
    props: {
      "iconButtonName": "utility:upload",
      "iconButtonVariant": "border",
      "iconDescription": $cmp.uploadText,
      "changeFocus": $cmp.handleFocus,
      "changeBlur": $cmp.handleBlur
    },
    key: 14,
    on: {
      "click": _m7 || ($ctx._m7 = api_bind($cmp.clickUpload))
    }
  })]), api_static_fragment($fragment3, 16, [api_static_part(2, null, api_dynamic_text($cmp.uploadImageLabel))])])]) : null]), api_element("div", stc9, [api_element("div", stc10, [$cmp.previewImageUrl ? api_static_fragment($fragment4, 20, [api_static_part(0, {
    style: $cmp.computedStyle,
    attrs: {
      "src": $cmp.previewImageUrl,
      "alt": $cmp.labels.imagePreview
    }
  }, null)]) : null, $cmp.previewImageUrl ? api_custom_element("appx-delete-icon-button", _appxDeleteIconButton, {
    props: {
      "description": $cmp.sharedLabels.deleteImage,
      "handleClick": $cmp.clickRemove,
      "disabled": $cmp.disabled
    },
    key: 21
  }) : null, !$cmp.previewImageUrl ? api_custom_element("c360-icon", _c360Icon, {
    props: {
      "iconName": "utility:image",
      "iconDescription": $cmp.sharedLabels.imagePlaceholder,
      "size": "small",
      "iconClass": "disabled"
    },
    key: 22
  }) : null])])]), api_element("div", stc11, [api_element("div", stc12, [$cmp.showRequiredError ? api_static_fragment($fragment5, 26, [api_static_part(1, null, api_dynamic_text($cmp.requiredText))]) : null])])]), $cmp.helpText ? api_element("div", stc13, [api_element("div", stc14, [api_custom_element("appx-message-box", _appxMessageBox, {
    props: {
      "type": "note",
      "message": $cmp.helpText,
      "noteTitle": $cmp.helpTextTitle,
      "withoutIcon": true
    },
    key: 29
  })])]) : null])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-kggjasjvvm";
tmpl.legacyStylesheetToken = "appx-imageUploader_imageUploader";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
